var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.18499V10.9583C0.75 11.1217 0.878333 11.25 1.04167 11.25H2.815C2.89083 11.25 2.96667 11.2208 3.01917 11.1625L9.38917 4.79833L7.20167 2.61083L0.8375 8.97499C0.779167 9.03333 0.75 9.10332 0.75 9.18499ZM11.0808 3.10666C11.3083 2.87916 11.3083 2.51166 11.0808 2.28416L9.71583 0.91916C9.48833 0.69166 9.12083 0.69166 8.89333 0.91916L7.82583 1.98666L10.0133 4.17416L11.0808 3.10666Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.aaf77e11.svg";
export { ForwardRef as ReactComponent };